var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGridNew = function SvgGridNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2550",
    d: "M14.084 4H6.656A2.656 2.656 0 0 0 4 6.656v7.43a2.656 2.656 0 0 0 2.656 2.656h7.428a2.656 2.656 0 0 0 2.655-2.657V6.656A2.656 2.656 0 0 0 14.084 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2550",
    d: "M31.343 4h-7.427a2.656 2.656 0 0 0-2.656 2.656v7.43a2.656 2.656 0 0 0 2.656 2.656h7.427A2.656 2.656 0 0 0 34 14.085V6.656A2.656 2.656 0 0 0 31.343 4M14.084 21.258H6.656A2.656 2.656 0 0 0 4 23.915v7.429A2.656 2.656 0 0 0 6.656 34h7.428a2.656 2.656 0 0 0 2.655-2.656v-7.43a2.656 2.656 0 0 0-2.655-2.656",
    opacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2550",
    d: "M32.298 28.764h-9.333a1.125 1.125 0 0 1 0-2.251h9.333a1.126 1.126 0 0 1 0 2.25"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2550",
    d: "M27.634 33.429a1.125 1.125 0 0 1-1.125-1.126v-9.335a1.126 1.126 0 1 1 2.25 0v9.335a1.126 1.126 0 0 1-1.125 1.126"
  })));
};
export default SvgGridNew;